import React from 'react';

const PolarisFooter = ({ slim = true }) => (
  <div className="page-footer page-footer--globalnav">
    <xc-footer
      client-id="myAccountWeb"
      {...(slim ? { 'slim-footer': true, theme: 'light' } : { })}
    />
  </div>
);

export default PolarisFooter;
